<script setup>
import SecondaryNavigationMenu from '@/components/layout/navigation/SecondaryNavigationMenu.vue';
import TrialInfoPanel from '@/components/layout/TrialInfoPanel.vue';
import { useUtilityNavigationMenu } from '@/composables/layout/navigation/useUtilityNavigationMenu';

const emits = defineEmits(['close']);

const { firstName, visibleUtilityNavigationMenuItems } = useUtilityNavigationMenu();

function close(event) {
  emits('close', event);
}
</script>

<template>
  <div class="!self-end !p-4" :style="{ width: 'var(--secondary-navigation-width)' }">
    <p v-if="firstName" class="typo-h5 !px-6 !py-4 text-primary">Hi, {{ firstName }}</p>
    <TrialInfoPanel visual-bridge class="!mt-6" @selected="close" />
    <SecondaryNavigationMenu
      :menu-items="visibleUtilityNavigationMenuItems"
      @update:selected="close($event)"
    />
  </div>
</template>
